import { render, staticRenderFns } from "./map-test.vue?vue&type=template&id=2b96dcd1&scoped=true&"
import script from "./map-test.vue?vue&type=script&lang=js&"
export * from "./map-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b96dcd1",
  null
  
)

export default component.exports